import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom'

/**
 * Shim for `next/link` on CRA — maps `href` to react-router navigation
 * and handles same-page hash scrolling smoothly.
 */
export default function NextLink({ href = '', children, ...rest }) {
  const navigate = useNavigate()
  const location = useLocation()

  if (/^(https?:|mailto:|tel:)/.test(href)) {
    return <a href={href} {...rest}>{children}</a>
  }

  if (href.startsWith('#')) {
    const onClick = (e) => {
      rest.onClick?.(e)
      e.preventDefault()
      const el = document.querySelector(href)
      el ? el.scrollIntoView({ behavior: 'smooth' }) : window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    return <a href={href} {...rest} onClick={onClick}>{children}</a>
  }

  const [pathname, hash] = href.split('#')
  const onClick = (e) => {
    rest.onClick?.(e)
    e.preventDefault()
    if (pathname === location.pathname) {
      if (hash) document.getElementById(hash)?.scrollIntoView({ behavior: 'smooth' })
      else window.scrollTo({ top: 0, behavior: 'smooth' })
    } else {
      navigate(pathname || '/')
      if (hash) setTimeout(() => document.getElementById(hash)?.scrollIntoView({ behavior: 'smooth' }), 140)
    }
  }
  return <RouterLink to={pathname + (hash ? `#${hash}` : '')} {...rest} onClick={onClick}>{children}</RouterLink>
}
